import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
	selector: 'app-side-panel',
	templateUrl: './side-panel.html',
	styleUrl: './side-panel.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidePanel {}
